import { render } from "./VehicleCommands.vue?vue&type=template&id=8547647e&scoped=true"
import script from "./VehicleCommands.vue?vue&type=script&lang=js"
export * from "./VehicleCommands.vue?vue&type=script&lang=js"

import "./VehicleCommands.vue?vue&type=style&index=0&id=8547647e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8547647e"]])

export default __exports__